import BaseTooltip, { type BaseTooltipProps } from "@common/controls/Tooltip/Base/component";
import { calcPointerLocation, calcTooltipLocation } from "@common/controls/Tooltip/lib";
import { useUpdated } from "@common/lib/hooks";
import { isEqual } from "lodash";
import React from "react";
import AppContext from "../App";

import "./style.less";

type Props = {
  base: BaseTooltipProps;
  target: HTMLElement;
};
export default (props: Props) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const [tooltip, setTooltip] = React.useState<BaseTooltipProps>(props.base);
  const appContext = React.useContext(AppContext);

  useUpdated(() => setTooltip(props.base), [props.base]);

  React.useLayoutEffect(() => {
    if (!ref.current || !tooltip) return;

    const location = calcTooltipLocation(props.target, ref.current);

    const pointerPosition = calcPointerLocation(props.target, ref.current);
    if (isEqual(pointerPosition, tooltip.pointerPosition)) {
      if (!isEqual(location, tooltip.location)) {
        setTooltip((x) => ({ ...x!, location }));
      }
    } else {
      setTooltip((x) => ({ ...x!, location, pointerPosition }));
    }
  }, [ref.current, props.target, tooltip]);

  return <BaseTooltip ref={ref} {...tooltip} className={appContext.context === "next" ? "admin _theme_" : undefined} />;
};
